// AdminDetailModal.jsx
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { AdminReservationDto, PaymentDto } from 'services/data-contracts';
import { useStoreWrapper } from 'stores/StoreHelper';
import moment from 'moment';
import { Row } from 'saladsoft-primitive';
import ServiceHelper from 'stores/ServiceHelper';

const AdminDetailModal = ({ reservation }: { reservation: AdminReservationDto }) => {
  // 예시 데이터 (실제로는 props로 전달받은 userData를 사용)
  const { uiStore } = useStoreWrapper();
  const [payment, setPayment] = useState<PaymentDto>();

  useEffect(() => {
    ServiceHelper?.adminReservationService
      ?.getPaymentByReservation1(reservation.id as number)
      .then((res) => {
        setPayment(res.data);
      });
  }, []);

  return (
    <>
      <ModalContent>
        <Row gap={20} alignItems="flex-start" justifyContent="space-between">
          <div style={{ flex: 0.6 }}>
            <InfoSection>
              <SectionTitle>기본 정보</SectionTitle>
              <InfoGrid>
                <InfoLabel>예약번호</InfoLabel>
                <InfoValue>
                  {reservation.hostawayReservationId} (<b>{reservation.reservationNo}</b>)
                </InfoValue>

                <InfoLabel>예약시간</InfoLabel>
                <InfoValue>
                  {moment(reservation.reservationDate).format('YYYY-MM-DD: HH:mm')}
                </InfoValue>
                <InfoLabel>지점명</InfoLabel>
                <InfoValue>{reservation.listingName}</InfoValue>
                <InfoLabel>숙박정보</InfoLabel>
                <InfoValue>
                  <Row justifyContent="flex-start" gap={40}>
                    <Row>
                      <InfoLabel>입실일 - </InfoLabel>
                      <InfoValue>{moment(reservation.arrivalDate).format('YYYY-MM-DD')}</InfoValue>
                    </Row>
                    <Row>
                      <InfoLabel>퇴실일 - </InfoLabel>
                      <InfoValue>
                        {moment(reservation.departureDate).format('YYYY-MM-DD')}
                      </InfoValue>
                    </Row>
                  </Row>
                </InfoValue>
              </InfoGrid>
            </InfoSection>

            <InfoSection>
              <SectionTitle>고객정보 {!reservation.guest && '(비회원예약)'}</SectionTitle>
              <InfoGrid>
                <InfoLabel>이름</InfoLabel>
                <InfoValue>
                  {reservation.guestFirstName} {reservation.guestLastName}
                </InfoValue>
                <InfoLabel>이메일</InfoLabel>
                <InfoValue
                  style={{ cursor: 'pointer', color: '#0078d4' }}
                  onClick={() => {
                    window.open(`mailto:${reservation.guest?.username}`, '_blank');
                  }}
                >
                  {reservation.guestEmail}
                </InfoValue>
                <InfoLabel>전화번호</InfoLabel>
                <InfoValue>
                  {reservation.guestCountryCode} {reservation.guestPhoneNumber}
                </InfoValue>
              </InfoGrid>
            </InfoSection>

            <InfoSection>
              <SectionTitle>결제정보</SectionTitle>
              <InfoGrid>
                <InfoLabel>순 결제금액</InfoLabel>
                <InfoValue>{reservation.totalAmount?.toLocaleString()}원</InfoValue>
                <InfoLabel>포인트 사용액</InfoLabel>
                <InfoValue>{reservation.usePoint?.toLocaleString()}원</InfoValue>
                <InfoLabel>바우처 사용액</InfoLabel>
                <InfoValue>
                  {reservation.voucherDiscountAmount
                    ? reservation.voucherDiscountAmount?.toLocaleString()
                    : '-'}
                  원
                </InfoValue>
                <InfoLabel>총 결제금액</InfoLabel>
                <InfoValue>{reservation.totalAmount?.toLocaleString()}원</InfoValue>
              </InfoGrid>
            </InfoSection>
          </div>
          <div style={{ flex: 0.4 }}>
            <InfoSection>
              <SectionTitle>카드 정보</SectionTitle>
              <InfoGrid>
                <InfoLabel>결제 방법</InfoLabel>
                <InfoValue>{payment?.cardType}</InfoValue>
                <InfoLabel>카드 번호</InfoLabel>
                <InfoValue>{payment?.cardNumber}</InfoValue>
                <InfoLabel>승인 일자</InfoLabel>
                <InfoValue>{moment(payment?.approvedDate).format('YYYY-MM-DD HH:mm:ss')}</InfoValue>
                <InfoLabel>결제 취소일</InfoLabel>
                <InfoValue>
                  {payment?.cancelDate
                    ? moment(payment?.cancelDate).format('YYYY-MM-DD HH:mm:ss')
                    : '-'}
                </InfoValue>

                <InfoLabel>카드영수증</InfoLabel>
                <InfoValue>
                  <a href={payment?.cardReceiptUrl} target="_blank" rel="noopener noreferrer">
                    카드영수증 보기
                  </a>
                </InfoValue>
              </InfoGrid>
            </InfoSection>

            <InfoSection>
              <SectionTitle>기타</SectionTitle>
              <InfoGrid>
                <InfoLabel>요청사항</InfoLabel>
                <InfoValue>{reservation.guestNote ? reservation.guestNote : '-'}</InfoValue>
              </InfoGrid>
            </InfoSection>
          </div>
        </Row>
      </ModalContent>

      <ButtonRow>
        <SecondaryButton
          onClick={() => {
            uiStore?.modal.close();
          }}
        >
          닫기
        </SecondaryButton>
        {/* <PrimaryButton>수정</PrimaryButton>
                <DangerButton>계정 비활성화</DangerButton> */}
      </ButtonRow>
    </>
  );
};

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid #eaeaea;
`;

const ModalTitle = styled.h2`
  margin: 0;
  font-size: 20px;
  color: #333;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 22px;
  color: #666;
`;

const ModalContent = styled.div`
  padding: 24px;
  max-height: 70vh;
  overflow-y: auto;
`;

const InfoSection = styled.div`
  margin-bottom: 24px;
`;

const SectionTitle = styled.div`
  font-weight: 600;
  font-size: 16px;
  color: #333;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #eaeaea;
`;

const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: 150px 1fr;
  grid-gap: 12px 24px;
`;

const InfoLabel = styled.div`
  color: #666;
  font-weight: 500;
  font-size: 14px;
`;

const InfoValue = styled.div`
  color: #333;
  font-size: 14px;
`;

const Tag = styled.span`
  display: inline-block;
  background-color: #e9f5fe;
  color: #0078d4;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  margin-right: 6px;
`;

const HistoryItem = styled.div`
  padding: 12px;
  border-bottom: 1px solid #f0f0f0;
  &:last-child {
    border-bottom: none;
  }
`;

const HistoryDate = styled.div`
  font-size: 12px;
  color: #666;
`;

const HistoryDescription = styled.div`
  font-size: 14px;
  margin: 4px 0;
`;

const HistoryUser = styled.div`
  font-size: 12px;
  color: #0078d4;
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid #eaeaea;
`;

const Button = styled.button`
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
`;

const SecondaryButton = styled(Button)`
  background-color: #f5f5f5;
  border: 1px solid #e0e0e0;
  color: #333;
  &:hover {
    background-color: #e9e9e9;
  }
`;

const PrimaryButton = styled(Button)`
  background-color: #0078d4;
  border: 1px solid #0078d4;
  color: white;
  &:hover {
    background-color: #006abe;
  }
`;

const DangerButton = styled(Button)`
  background-color: #d13438;
  border: 1px solid #d13438;
  color: white;
  &:hover {
    background-color: #c12e32;
  }
`;

export default AdminDetailModal;
